import { useState } from "react";
import { IncorporationWizardFormContext, type StepComponentType } from "./hooks/IncorporationWizardFormContext";
import { buildSteps } from "./utils";
import { SI_NO_OPTIONS, type IncorporationWizardInitialData } from "@/schemas/incorporation";
import "@/App.css";

export default function IncorporationWizardForm({
  initialData,
}: {
  initialData?: IncorporationWizardInitialData;
}) {
  // es_benficiario es addicion nueva para fallback por si hay usuarios con data vieja
  const cleanInitialData = initialData ? {
    ...initialData,
    incorporationContact: initialData.incorporationContact.map(contact => ({
      ...contact,
      es_beneficiario: contact.porcentaje_beneficio > 0 ? SI_NO_OPTIONS[0] : SI_NO_OPTIONS[1],
    })),
  } : undefined;
  const [currIndex, setCurrIndex] = useState(0);
  const [data, setData] = useState<IncorporationWizardInitialData | undefined>(cleanInitialData);
  const steps: StepComponentType[] = buildSteps(data);
  const CurrentStep: StepComponentType = steps[currIndex];

  const canNext = currIndex < steps.length - 1;
  const canBack = currIndex > 0;

  const next = () => canNext && setCurrIndex(i => Math.min(i + 1, steps.length - 1));
  const back = () => canBack && setCurrIndex(i => Math.max(i - 1, 0));

  return (
    <IncorporationWizardFormContext.Provider
      value={{ currIndex, setCurrIndex, steps, data, setData, canNext, canBack, next, back}}
    >
      <CurrentStep />
    </IncorporationWizardFormContext.Provider>
  );
}